import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const get = async (queryParam, setParams) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/custom-field',
    params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/custom-field/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/custom-field',
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/custom-field/${id}`,
    data,
  })

  return response?.data
}

export const deleteSingle = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/custom-field/${id}`,
  })

  return response?.data
}
